<template>
    <div class="content-wrapper">
         <app-breadcrumb :page-title="$t('buyerrequeststatus')" :directory="$t('datatables')" :icon="'grid'"/>
        <div class="card card-with-search border-0 card-with-shadow">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="text_input">{{ $t('title') }}</label>  
                        <div class="form-group-with-icon">
                            <input type="text" name="" id="text_input" placeholder="Tile" autocomplete="off" class="form-control ">
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-sm-6">
                        <label for="password_input">{{ $t('description') }}</label>         
                        <div class="form-group-with-icon">
                            <textarea type="text" name="" cols="15" rows="5" id="password_input" placeholder="Description" autocomplete="off" class="form-control " ></textarea>
                        </div>
                    </div>
                </div>
                <div class="text-justify">
                    <div class="mb-primary">
                        <app-tab :tabs="tabsHorizontal" type="horizontal"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
 export default {
        name: "Tabs",
        components: {},
        data() {
            return {
                icon: 'settings',
                tabsHorizontal: [
                    {
                        "icon": "send",
                        "name": "Products",
                        "component": "buyer-request-detail-products",
                        "permission": ""
                    },
                    {
                        "icon": "lock",
                        "name": "Review",
                        "component": "buyer-request-detail-review",
                        "permission": ""
                    },
                ],
            }
        }
    }
</script>
